<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Customer</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRiple icon="pi pi-search" title="Back to Search"
                                        class="p-button p-button-success p-mr-2" (click)="goBack($event)"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <form [formGroup]="_Customerform">
                            <table class="normal-table">
                                <tr>
                                    <td style="width:17%" class="text-right">
                                        Customer Name <span class="hlt-txt">*</span>
                                    </td>
                                    <td><input type="text" formControlName="customername" (focusout)="VerifyCustomer()" maxlength="150" pInputText>
                                        <span class="text-danger"
                                        *ngIf="(_submitted || _Customerform.get('customername').touched) && _Customerform.get('customername').errors?.CustomersiteRequired">
                                        Please Enter Customer Name
                                    </span> </td>
                                    <!-- <td style="width:17%" class="text-right">
                                        Customer Tally ID
                                    </td>
                                    <td><input type="text" formControlName="tallyid" (keypress)="keypress.kpNumber($event)" maxlength="20" pInputText> </td> -->
                                    <td class="text-right">Company Type <span class="hlt-txt">*</span></td>

                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" placeholder="Select"
                                            [options]="_CompanyType" optionLabel="metasubdescription"
                                            optionValue="metasubcode" formControlName="companytypecode">
                                        </p-dropdown>
                                        <span class="text-danger"
                                        *ngIf="(_submitted || _Customerform.get('companytypecode').touched) && _Customerform.get('companytypecode').errors?.CustomersiteRequired">
                                        Please Select Company Type
                                    </span>
                                        <!-- <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                            [options]="_CompanyType" 
                                            optionValue="metasubcode" optionLabel="metasubdescription" formControlName="companytypecode">
                                        </p-dropdown> -->
                                    </td>
                                    <td class="text-right">Is Transporter <span class="hlt-txt">*</span></td>
                                    <td>
                                        <div class="p-formgroup-inline">
                                           
                                                <div class="p-field-radiobutton" *ngFor="let PF of _Transporter">
                                                    <p-radioButton  name="istransportercode" value="M"  label={{PF.metasubdescription}}
                                                         formControlName="istransportercode" value={{PF.metasubcode}}>
                                                    </p-radioButton>
                                                </div>
                                        </div>
                                        <span class="text-danger"
                                        *ngIf="(_submitted || _Customerform.get('istransportercode').touched) && _Customerform.get('istransportercode').errors?.CustomersiteRequired">
                                        Please Select Is Transporter
                                    </span>
                                    </td>
                                    <!-- <td></td>
                                    <td></td> -->
                                </tr>
                                <tr>
                                    
                                    <td class="text-right">Billing Cycle <span class="hlt-txt">*</span></td>
                                    <td>
                                        <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                            [options]="_BillingCycle" optionValue="metasubcode"
                                            optionLabel="metasubdescription" formControlName="billingcyclecode">
                                        </p-dropdown>
                                        <span class="text-danger"
                                        *ngIf="(_submitted || _Customerform.get('billingcyclecode').touched) && _Customerform.get('billingcyclecode').errors?.CustomersiteRequired">
                                        Please Select Billing Cycle
                                    </span>
                                    </td>
                                    <td class="text-right">PAN No </td>
                                    <td>
                                        <!-- <input type="text" mask="aaaa9999a" characterPattern="[А-Яа-я]" formControlName="pan" maxlength="10" pInputText> -->
                                        <!-- <p-inputMask formControlName="pan" maxlength="10" mask="aaaaa9999a"></p-inputMask> -->
                                        <input type="text" formControlName="pan" maxlength="10" pInputText>
                                    </td>
                                    <!-- 
                                <div class="p-field-radiobutton" *ngFor="let Pm of _PayModes">
                                    <p-radioButton name="paymode" value="M" formControlName="paymode"
                                        label={{Pm.metasubdescription}} value={{Pm.metasubcode}}>
                                    </p-radioButton>
                                </div> -->

                                    <!-- <td>
                                    <div class="p-formgroup-inline">
                                    <div class="form-group">
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="groupname" value="normaldelivery" inputId="1"
                                                label="Normal Delivery"></p-radioButton><i class="las la-info-circle"
                                                pTooltip="If your total amount is less than $500 shipping charge is 5$ other wise shipping charge is 0$"
                                                tooltipPosition="bottom"></i>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="groupname" value="expressdelivery" inputId="2"
                                                label="Express Delivery"></p-radioButton><i class="las la-info-circle"
                                                pTooltip="If your total amount is less than $500 shipping charge is 8$ other wise shipping charge is 0$"
                                                tooltipPosition="bottom"></i>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="groupname" value="selfpickup" inputId="3"
                                                label="Selfpick Up">
                                            </p-radioButton>
                                        </div>
                                    </div>
                                </div>
                                </td> -->
                                </tr>
                                <tr>
                                    <!-- <td class="text-right">Pre-Quote Status<span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                        [options]="_QuoteStatus" optionValue="code"  optionLabel="quotename">
                                    </p-dropdown>
                                </td> -->
                                    <td [hidden]="hideStatus" class="text-right">Status <span class="hlt-txt">*</span>
                                    </td>
                                    <td [hidden]="hideStatus">
                                        <p-dropdown [autoDisplayFirst]="false" formControlName="recordstatuscode"
                                            placeholder="Select" [filter]="true" [options]="_Status"
                                            optionValue="metasubcode" optionLabel="metasubdescription">
                                        </p-dropdown>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-center">
                                        <button pButton label="Save" class="p-button-success" (click)="onSave()"
                                            icon="las la-check"></button>
                                        <button pButton label="Clear" class="p-button-warning" (click)="reset()"
                                            icon="las la-broom"></button>
                                    </td>
                                </tr>
                            </table>
                        </form>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom" (click)="exportExcel()"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="ManageCustomersList" [rows]="10" [paginator]="true" [columns]="cols"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['customername','tallyid','istransporter','companytype','pan','billingcycle','recordstatus']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="customername">Customer Name <p-sortIcon
                                                field="customername">
                                            </p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="tallyid">Customer Tally ID <p-sortIcon field="tallyid">
                                            </p-sortIcon>
                                        </th> -->
                                        <th pSortableColumn="companytype">Company Type <p-sortIcon field="companytype">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="istransporter">Is Transporter <p-sortIcon
                                                field="istransporter">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="pan">PAN No <p-sortIcon field="pan">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="billingcycle">Billing Cycle <p-sortIcon
                                                field="billingcycle">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="recordstatus">Status <p-sortIcon field="recordstatus">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList let-ri="rowIndex">
                                    <tr (dblclick)="onRowCustomerselect(_ManageCustomerList,ri)">
                                        <td>
                                            {{_ManageCustomerList.customername}}
                                        </td>
                                        <!-- <td>
                                            {{_ManageCustomerList.tallyid}}
                                        </td> -->
                                        <td>
                                            {{_ManageCustomerList.companytype}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.istransporter}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.pan}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.billingcycle}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.recordstatus}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <!-- Debug -->
                        <div #editor style="width: 500px;height: 250px; overflow-y:auto;"></div>


                    </div>
                    <div class="page-loader" *ngIf="_IsProgressSpinner">
                        <p-progressSpinner strokeWidth="5"></p-progressSpinner>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<p-toast position="bottom-right"></p-toast>